export const BITACORAS_DEFAULT_COLUMNS = [
  { id: 'acciones1', label: 'Acciones (Crear Adenda)', minWidth: 200, sortable: false, disableToggle: true, fixed: true },
  { id: 'ClaveTipoBitacoraEspecial', label: 'Tipo Bitácora Especial', minWidth: 210, sortable: true, disableToggle: true, fixed: true },
  { id: 'ClaveBitacora', label: 'Clave Bitácora', minWidth: 150, sortable: true },
  { id: 'SerieBitacora', label: 'Serie Bitácora', minWidth: 140, sortable: true },
  { id: 'FolioBitacora', label: 'Folio Bitácora', minWidth: 140, sortable: true },
  { id: 'SerieRemision', label: 'Serie Remisión', minWidth: 140, sortable: true },
  { id: 'FolioRemision', label: 'Folio Remisión', minWidth: 140, sortable: true },
  { id: 'FechaUltimaModificacion', label: 'Fecha Modificación', minWidth: 200, sortable: true },
  { id: 'OrigenFechaHoraSalida', label: 'Fecha Salida', minWidth: 200, sortable: true },
  { id: 'DestinoFechaHoraLlegada', label: 'Fecha Llegada', minWidth: 200, sortable: true },
  { id: 'SerieFactura', label: 'Serie Factura', minWidth: 120, sortable: true },
  { id: 'FolioFactura', label: 'Folio Factura', minWidth: 120, sortable: true },
  { id: 'RemitenteRFC', label: 'RFC Remitente', minWidth: 150, sortable: true },
  { id: 'RemitenteNombre', label: 'Nombre Remitente', minWidth: 200, sortable: true },
  { id: 'Estatus', label: 'Estatus', minWidth: 80, sortable: true },
  { id: 'OrigenNombre', label: 'Origen', minWidth: 200, sortable: true },
  { id: 'DestinoNombre', label: 'Destino', minWidth: 200, sortable: true },
  { id: 'TotalDistanciaRecorrida', label: 'KM', minWidth: 80, sortable: true },
  { id: 'OperadorNombre', label: 'Conductor', minWidth: 150, sortable: true },
  { id: 'MercanciasPesoNetoTotal', label: 'Peso', minWidth: 100, sortable: true },
  { id: 'MercanciaDescripcion', label: 'Mercancía', minWidth: 150, sortable: true },
  { id: 'ClaveRemision', label: 'Clave Remisión', minWidth: 120, sortable: true },
  { id: 'ClaveEstatus', label: 'Clave Estatus', minWidth: 120, sortable: true },
  { id: 'ClaveConductor', label: 'Clave Conductor', minWidth: 120, sortable: true },
  { id: 'ClaveUnidad', label: 'Clave Unidad', minWidth: 120, sortable: true },
  { id: 'ClaveTipoUnidad', label: 'Clave Tipo Unidad', minWidth: 120, sortable: true },
  { id: 'IdVehicularPlacaVehiculoMotor', label: 'Placa Tractor', minWidth: 120, sortable: true },
  { id: 'RemolquePlaca', label: 'Placa Remolque', minWidth: 120, sortable: true },
  { id: 'IdVehicularConfiguracion', label: 'Configuración', minWidth: 120, sortable: true },
  { id: 'IdVehicularAnioModeloVM', label: 'Año Modelo', minWidth: 110, sortable: true },
  { id: 'OrigenRFC', label: 'RFC Origen', minWidth: 150, sortable: true },
  { id: 'OrigenDomicilioCalle', label: 'Calle Origen', minWidth: 200, sortable: true },
  { id: 'DestinoRFC', label: 'RFC Destino', minWidth: 150, sortable: true },
  { id: 'DestinoDomicilioCalle', label: 'Calle Destino', minWidth: 200, sortable: true },
  { id: 'MercanciaCantidad', label: 'Cantidad', minWidth: 120, sortable: true },
  { id: 'MercanciaBienesTransportados', label: 'Bienes Transp.', minWidth: 130, sortable: true },
  { id: 'MercanciaClaveMarterialPeligroso', label: 'Clave Mat. Peligroso', minWidth: 150, sortable: true },
  { id: 'MercanciaMaterialPeligroso', label: 'Material Peligroso', minWidth: 130, sortable: true },
  { id: 'DistanciaRecorrida', label: 'Distancia (KM)', minWidth: 130, sortable: true },
  { id: 'FederalPermisoSCT', label: 'Permiso SCT', minWidth: 160, sortable: true },
  { id: 'FederalNumeroPermisoSCT', label: 'Num. Permiso SCT', minWidth: 200, sortable: true },
  { id: 'FederalNombreAseguradora', label: 'Aseguradora', minWidth: 220, sortable: true },
  { id: 'FederalNumeroPolizaSeguro', label: 'Póliza Seguro', minWidth: 200, sortable: true },
  { id: 'TransporteInternacional', label: 'Transp. Internacional', minWidth: 200, sortable: true },
  { id: 'Version', label: 'Versión', minWidth: 120, sortable: true },
  { id: 'acciones2', label: 'Acciones (Ingresar Factura)', minWidth: 220, sortable: false, disableToggle: true, fixed: true },
];

/**
 * Convierte el nombre de un campo de la API en una etiqueta legible.
 * 'MercanciasPesoBrutoTotal' -> 'Mercancias Peso Bruto Total'
 *
 * @param {String} campo
 * @returns {String}
 */
export const etiquetaDesdeCampo = (campo) =>
  String(campo)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .trim();

/**
 * Arma la lista de columnas disponibles a partir de los registros recibidos.
 *
 * Las columnas curadas quedan visibles por defecto, para que la pantalla se vea
 * igual que siempre. Los campos que la API devuelve y no estaban modelados se
 * agregan ocultos, disponibles en el diálogo de columnas.
 *
 * @param {Array<Object>} registros Respuesta de la consulta de bitácoras.
 * @param {Array<Object>} columnasBase Columnas curadas.
 * @returns {Array<Object>}
 */
export const construirColumnasBitacoras = (
  registros = [],
  columnasBase = BITACORAS_DEFAULT_COLUMNS
) => {
  const base = columnasBase.map((col) => ({ visibleByDefault: true, ...col }));
  const idsBase = new Set(base.map((col) => col.id));

  const camposVistos = new Set();
  (Array.isArray(registros) ? registros : []).forEach((registro) => {
    if (registro && typeof registro === 'object') {
      Object.keys(registro).forEach((campo) => camposVistos.add(campo));
    }
  });

  const derivadas = [...camposVistos]
    .filter((campo) => !idsBase.has(campo))
    .sort()
    .map((campo) => ({
      id: campo,
      label: etiquetaDesdeCampo(campo),
      minWidth: 150,
      sortable: true,
      visibleByDefault: false,
    }));

  return [...base, ...derivadas];
};

/**
 * Combina las columnas disponibles con la configuración que el usuario guardó.
 *
 * Descarta los IDs guardados que ya no existen (config vieja en localStorage) y
 * respeta la visibilidad elegida, salvo en las columnas fijas.
 *
 * @param {Array<Object>} columnasDisponibles
 * @param {Array<{id: String, visible: Boolean}>} configGuardada
 * @returns {Array<Object>}
 */
export const fusionarConfigColumnas = (columnasDisponibles, configGuardada) => {
  const guardadas = Array.isArray(configGuardada) ? configGuardada : [];
  const porId = new Map(columnasDisponibles.map((col) => [col.id, col]));

  const enOrden = guardadas
    .filter((guardada) => porId.has(guardada.id))
    .map((guardada) => {
      const col = porId.get(guardada.id);
      return { ...col, visible: col.disableToggle ? true : Boolean(guardada.visible) };
    });

  const yaPuestas = new Set(enOrden.map((col) => col.id));
  const nuevas = columnasDisponibles
    .filter((col) => !yaPuestas.has(col.id))
    .map((col) => ({ ...col, visible: col.disableToggle ? true : col.visibleByDefault !== false }));

  return [...enOrden, ...nuevas];
};
